import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './Question.scss';

const Question = props => {
  const {
    handleSnackBar,
    isCategory = false,
    onChangeOptions,
    answers,
  } = props;
  const { options, cmstype, msid, descriptor } = props.question || {};

  const [selected, setSelected] = useState([]);

  const handleClick = e => {
    const newEntry = {
      key: e.target.value,
      value: e.target.value,
    };
    if (e.target.type === 'checkbox') {
      let newState = selected;
      let updatedEntries = [];
      if (Object.values(selected).some(item => item.key === newEntry.key)) {
        updatedEntries = selected.filter(item => item.key !== newEntry.key);
        setSelected([...updatedEntries]);
        newState = updatedEntries;
      } else if (selected.length === descriptor?.maxlimitforselection) {
        updatedEntries = selected.filter((item, index) => index > 0);
        updatedEntries.push(newEntry);
        setSelected([...updatedEntries]);
        newState = updatedEntries;
      } else {
        setSelected([...selected, newEntry]);
        newState = [...selected, newEntry];
      }
      onChangeOptions(e, newState);
    } else {
      setSelected(newEntry.value);
      onChangeOptions(e, newEntry.value);
    }
  };

  useEffect(
    () => {
      if (Array.isArray(answers[msid]) && !!answers[msid].length) {
        const answerMap = answers[msid].map(answer => ({
          key: answer,
          value: answer,
        }));
        setSelected(answerMap);
        return;
      }
      setSelected([]);
    },
    [props.question],
  );

  const setChecked = (optionMsid, optionId) => {
    if (Array.isArray(answers[optionMsid]) && answers[optionMsid].length) {
      return answers[optionMsid].includes(optionId.toString());
    } else if (!Array.isArray(answers[optionMsid])) {
      return optionId.toString() === answers[optionMsid];
    }
    return false;
  };

  return (
    <>
      {options.map((option, index) => (
        <li className={s.questionBox}>
          <input
            type={cmstype === 'SURVEYMCQSINGLECHOICE' ? 'radio' : 'checkbox'}
            id={`${index}_${msid || 'category'}`}
            key={`${index}_${msid || 'category'}`}
            name={msid || 'category'}
            value={option.id}
            checked={setChecked(msid || 'category', option.id)}
            onClick={e => handleClick(e)}
          />
          <label htmlFor={`${index}_${msid || 'category'}`}>
            <span className={isCategory ? s.optionTitle : s.optionDesc}>
              {option.option}
            </span>
            {!props.isWapView &&
              (option.description && (
                <span className={s.optionDesc}>{option.description}</span>
              ))}
          </label>
          {props.isWapView &&
            isCategory && (
              <span
                onClick={() => {
                  handleSnackBar(option.option, option.description);
                }}
                className={s.infoIcon}
              >
                i
              </span>
            )}
        </li>
      ))}
    </>
  );
};

Question.propTypes = {
  handleSnackBar: PropTypes.func.isRequired,
  isCategory: PropTypes.bool,
  onChangeOptions: PropTypes.func.isRequired,
  question: PropTypes.object,
  answers: PropTypes.object,
  isWapView: PropTypes.bool,
};

Question.defaultProps = {
  isWapView: false,
  isCategory: false,
  answers: {},
  question: {},
};

export default React.memo(Question);
